import Phaser from "phaser";

export const eventBus = new Phaser.Events.EventEmitter();
